import React, { Component } from 'react';
import styled from 'styled-components';
import { Col, Row, Container, Button } from './';
import FooterSocialLinks from './footer/footer-social-links';
import PropTypes from 'prop-types';

export const FooterDiv = styled.div`
  background-color: #36363e;
  padding-top: 20px;
  color: #bbb;
  font-size: 15px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem){
    font-size: 13px;
  }
  line-height: 1.8;
  .hui-footer{
    &__title {
      margin-top: 0;
      margin-bottom: 10px;
      font-size: 14px;
      color: #f9f9f9;
      text-transform: none;
      font-weight: normal;
    }
    &__links-list {
      margin: 0;
      padding: 0;
      list-style: none;
      a {
        color: #aaa;
        cursor: pointer;
        text-decoration: none;
        :hover {
          color:#888;
        }
      }
    }
    &__freecall {
      color: #f9f9f9;
      margin-top: 5px;
      @media (min-width: ${props => props.theme.breakpoints.md}rem){
        margin-top: 15px;
      }
      margin-bottom: 5px;
      a{
        color: inherit;
        text-decoration: none;
        font-size: 15px;
      }
    }
    &__working-hours {
      font-size: 13px;
      display:block;
      text-transform: uppercase;
      span {
        text-transform: none;
      }
    }
    &__who-text {
        font-size: 13px;
        line-height:1.5;
    }
    &__sect,
    &__sect--list,
    &__extra-links {
      margin-top: 30px;
      padding-left: 45px;
      padding-right: 45px;
    }
    &__extra-links{
      color: #666;
      text-align: center;
      .link--footer {
        color: #666;
        cursor: pointer;
        text-decoration: none;
        :hover {
          color:#888;
        }
      }
    }
    &__hidden-xs {
      display: none;
      @media (min-width: ${props => props.theme.breakpoints.md}rem){
        display: block;
      }
    }
    &__col--first{
      padding-left: 10px;
    }
    &__col{
      padding-left: 10px;
      padding-bottom: 20px;
      @media (min-width: ${props => props.theme.breakpoints.md}rem){
        padding-bottom: 0px;
      }
    }
  }
}
`;
export const FooterSocial = styled.div`
  padding-top:20p;
  background-color: #303034;
  color: #bbb;
  font-size: 13px;
  .hui-footer{
    &__sect--copyright {
      text-align: center;
      @media (min-width: ${props => props.theme.breakpoints.lg}rem){
        text-align: left;
      }
      color: #bbb;
      a {
        color: #bbb;
        cursor: pointer;
        text-decoration: none;
        :hover {
          color:#888;
        }
      }
      .hui-footer__partners{
        color: #888;
        a {
          color: #888;
        }
      }
    }
    &__sect--get-app{
      text-align:center;
      .hui_footer__get-app-link {
         color: #f96f12;
         cursor: pointer;
         text-decoration: none;
         :hover {
           color: #ff8e33;
           text-decoration: underline;
         }
      }
      .hui-footer__app-banner {
        display: inline-block;
        margin-left: 10px;
        padding-bottom: 5px;
      }
    }
    &__sr-only {
      display: none;
    }
  }
  .hui-footer__sect--social {
    @media (min-width: ${props => props.theme.breakpoints.lg}rem){
       padding-top: 10px;
    }
  }
  .hui-footer__social {
    display: table;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    font-size: 15px;
  }
  .hui-footer__social-icons {
    display: table-cell;
    text-align: center;
  }
  span[class^=hui-footer__social] {
      background-color: #ddd;
      position: relative;
      display: block;
      float: left;
      width: 33px;
      height: 33px;
      border-radius: 50%;
      margin-left:4px;
   }

  .hui-footer__social-icons, .hui__social-icons {
    span[class^="social-icon-"] {
      position: relative;
      width: 2.2em;
      height: 2.2em;
      text-indent: -9999px;
      float: left;
      display: block;
    }
    span[class^="social-icon-"]:before,
    span[class^="social-icon-"]:after {
      font-family: 'hui-icons';
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-indent: 0;
      position: absolute;
      top: 0;
      left: 0;
    }
    span[class^="social-icon-"]:before {
      content: "\f111";
      font-size: 2.2em;
    }
    span[class^="social-icon-"]:after {
      color: #fff;
      font-size: 1.2em;
      top: .5em;
      left: .4em;
    }
    span[class="social-icon-facebook"]:after {
      left: .5em;
    }
    span[class="social-icon-google-plus"]:after {
      top: 0.7em;
      left: 0.3em;
      font-size: 1em;
    }
    span[class="social-icon-instagram"]:after {
      left: 0.3em;
    }

    .social-icon-facebook:before {
      color: #3b5998;
    }
    .social-icon-google-plus:before {
      color: #dd4b39;
    }
    .social-icon-linkedin:before {
      color: #007bb6;
    }
    .social-icon-twitter:before {
      color: #55acee;
    }
    .social-icon-pinterest-p:before {
      color: #cb2027;
    }
    .social-icon-instagram:before {
      color: #9b6954;
    }
    .social-icon-facebook:after {
      content: "\f09a";
    }
    .social-icon-google-plus:after {
      content: "\f0d5";
    }
    .social-icon-linkedin:after {
      content: "\f0e1";
    }
    .social-icon-twitter:after {
      content: "\f099";
    }
    .social-icon-pinterest-p:after {
      content: "\f231";
    }
    .social-icon-instagram:after {
      content: "\f16d";
    }
`;
const ButtonFooter = Button.extend`
  font-size: 13px;
  padding: 12px 10px;
  min-width: 120px;
  text-align: center;
  line-height: 1.15;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    max-width: 200px;
  }
`;
const ContainerFooter = Container.extend`
  max-width: 1200px;
`;

const d = new Date();

export class Footer extends Component {
  static propTypes = {
    siteSource: PropTypes.string
  };
  render() {
    const { siteSource } = this.props;
    return (
      <div>
        <FooterDiv>
          <ContainerFooter>
            <Row>
              <Col xs={0} sm={0} md={0} lg={3}>
                <div className="hui-footer__title">Who are hipages?</div>
                <p className="hui-footer__who-text">
                  As Australia&apos;s most visited building and renovation website, hipages is your
                  platform for taking your building or renovation project from concept to
                  completion.
                </p>
                <p className="hui-footer__who-text">
                  We&apos;ve been connecting Australians with local trade professionals and home
                  services for over {d.getFullYear() - 2004} years.
                </p>
              </Col>
              <Col xs={12} sm={12} md={3} lg={2}>
                <div className="hui-footer__col--first">
                  <h6 className="hui-footer__title hui-footer__hidden-xs">About</h6>
                  <ul className="hui-footer__links-list">
                    <li>
                      <a
                        href="http://www.hipagesgroup.com.au/"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  About - About hipages Group"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        About hipages Group
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://www.hipagesgroup.com.au/careers"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  About - Career Opportunities"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Careers at hipages
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://www.hipagesgroup.com.au/team"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  About - Meet the Team"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Meet the Team
                      </a>
                    </li>
                    <li>
                      <a
                        href="/advertise"
                        className="hui-footer__hidden-xs"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  About - List Your Business"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        List your Business
                      </a>
                    </li>
                    <li>
                      <a
                        href="/contactus"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  About - Contact Us"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={2}>
                <div className="hui-footer__col">
                  <h6 className="hui-footer__title hui-footer__hidden-xs">Resources</h6>
                  <ul className="hui-footer__links-list">
                    <li>
                      <a
                        href="/articles"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  Resources -  Articles / Hints And Tips"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Articles
                      </a>
                    </li>
                    <li>
                      <a
                        href="/photos"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  Resources - Inspiration / Photos"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Photos
                      </a>
                    </li>
                    <li className="hui-footer__hidden-xs">
                      <a
                        href="/content/all_licensing"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  Resources - Licensing"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Licensing
                      </a>
                    </li>
                    <li className="hui-footer__hidden-xs">
                      <a
                        href="/content/council"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  Resources - Council Regulations"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Council Regulations
                      </a>
                    </li>
                    <li className="hui-footer__hidden-xs">
                      <a
                        href="/trust"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  How We Work - Trust and Quality"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Trust & Quality
                      </a>
                    </li>
                    <li className="hui-footer__hidden-xs">
                      <a
                        href="/voice"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  Alexa - Voice"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Voice
                      </a>
                    </li>
                    <li className="hui-footer__hidden-xs">
                      <a
                        href="/local_categories/all"
                        data-ga-category="Footer"
                        data-ga-action="Footer - Clicked  Searches - Local Categories"
                        data-ga-label={`Footer - ${siteSource}`}
                      >
                        Browse All Categories
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={2}>
                <div className="hui-footer__col">
                  <h6 className="hui-footer__title">Find a Tradie</h6>
                  <ButtonFooter
                    tag="a"
                    primary
                    block
                    href="/get_quotes_simple"
                    data-ga-category="Footer"
                    data-ga-action="Footer - Clicked  Get Started - Post a Job"
                    data-ga-label={`Footer - ${siteSource}`}
                  >
                    Get Quotes
                  </ButtonFooter>
                  <p className="hui-footer__freecall">
                    Freecall <a href="tel:1300217968">1300 217 968</a>
                  </p>
                  <span className="hui-footer__working-hours">Mon - Fri: 7am - 11pm (AEST)</span>
                  <span className="hui-footer__working-hours">Sat - Sun: 8am - 10pm (AEST)</span>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="hui-footer__col">
                  <h6 className="hui-footer__title">Advertise with Us</h6>
                  <ButtonFooter
                    secondary
                    tag="a"
                    block
                    href="/advertise"
                    data-ga-category="Footer"
                    data-ga-action="Footer - Clicked  Get Started - List Your Business"
                    data-ga-label={`Footer - ${siteSource}`}
                  >
                    List your Business
                  </ButtonFooter>
                  <p className="hui-footer__freecall">
                    Call <a href="tel:0283961397">(02) 8396 1397</a>
                  </p>
                  <span className="hui-footer__working-hours">Mon - Fri: 9am - 5:30pm (AEST)</span>
                  <span className="hui-footer__working-hours">
                    Sat - Sun: <span>Leave us a message.</span>
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <p className="hui-footer__extra-links hui-footer__hidden-xs">
                  <a
                    href="/tradesman_names"
                    className="link--footer"
                    data-ga-category="Footer"
                    data-ga-action="Footer - Clicked  Searches - Tradesmen By Name"
                    data-ga-label={`Footer - ${siteSource}`}
                  >
                    Tradesmen by Name
                  </a>{' '}
                  ·{' '}
                  <a
                    href="/trade_business_names"
                    className="link--footer"
                    data-ga-category="Footer"
                    data-ga-action="Footer - Clicked  Searches - Trades By Business"
                    data-ga-label={`Footer - ${siteSource}`}
                  >
                    Trades by Business
                  </a>{' '}
                  ·{' '}
                  <a
                    href="/login"
                    className="link--footer"
                    data-ga-category="Footer"
                    data-ga-action="Footer - Clicked  Business - Login"
                    data-ga-label={`Footer - ${siteSource}`}
                  >
                    Advertiser Login
                  </a>{' '}
                  ·{' '}
                  <a
                    href="/contactus"
                    className="link--footer"
                    data-ga-category="Footer"
                    data-ga-action="Footer - Clicked  Business - Support"
                    data-ga-label={`Footer - ${siteSource}`}
                  >
                    Customer Support
                  </a>
                </p>
              </Col>
            </Row>
          </ContainerFooter>
        </FooterDiv>
        <FooterSocial>
          <ContainerFooter>
            <Row>
              <Col xs={12} lg={4}>
                <div className="hui-footer__sect--copyright">
                  <p>
                    hipages © {new Date().getFullYear()} -{' '}
                    <a
                      href="/sitemap"
                      className="link--footer"
                      data-ga-category="Footer"
                      data-ga-action="Footer - Clicked  About - Site Map"
                      data-ga-label={`Footer - ${siteSource}`}
                    >
                      Sitemap
                    </a>{' '}
                    ·{' '}
                    <a
                      href="/terms"
                      className="link--footer"
                      data-ga-category="Footer"
                      data-ga-action="Footer - Clicked  About - Terms & Conditions"
                      data-ga-label={`Footer - ${siteSource}`}
                    >
                      Terms
                    </a>{' '}
                    ·{' '}
                    <a
                      href="/privacy"
                      className="link--footer"
                      data-ga-category="Footer"
                      data-ga-action="Footer - Clicked  About - Privacy Policy"
                      data-ga-label={`Footer - ${siteSource}`}
                    >
                      Privacy
                    </a>
                  </p>
                  <p className="hui-footer__partners">
                    Partner sites: Natural Therapy Pages · Pet Pages · realestate.com.au ·
                    carsguide.com.au
                  </p>
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className="hui-footer__sect--social">
                  <FooterSocialLinks siteSource={siteSource} />
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className="hui-footer__sect--get-app">
                  <Row>
                    <Col xs={12}>
                      <p>
                        <a href="/get-the-app" className="hui_footer__get-app-link">
                          Get the app — and get it done
                        </a>
                      </p>
                    </Col>
                    <Col xs={12}>
                      <a
                        className="hui-footer__app-banner"
                        href="http://app.appsflyer.com/id369786244?pid=hipages&amp;c=footer_mobile"
                        title="Download the hipages app on the App Store"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          role="presentation"
                          alt="App Store"
                          src="https://assets.homeimprovementpages.com.au/images/logo-app-store-v3.png"
                          className="valign_middle mrm"
                          width="130"
                          height="40"
                        />
                      </a>
                      <a
                        className="hui-footer__app-banner"
                        href="http://app.appsflyer.com/com.hip.consumer.android?pid=hipages&amp;c=footer_desktop"
                        title="Download the hipages app on Google Play"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          role="presentation"
                          alt="Play Store"
                          src="https://assets.homeimprovementpages.com.au/images/logo-google-play-v3.png"
                          className="valign_middle mrm"
                          width="130"
                          height="40"
                        />
                      </a>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </ContainerFooter>
        </FooterSocial>
      </div>
    );
  }
}
